import { FileDownload } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const downloadBase64File = (contentType, base64Data, fileName) => {
  if (contentType && base64Data && fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
};


export const COLUMNSPLANFORMATIVOP = [
  {
    header: "Eje",
    accessorKey: "eje",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Programa",
    accessorKey: "programa",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Formación",
    accessorKey: "new_maestrodecurso",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSCATALOGO = [
  {
    header: "Eje",
    accessorKey: "eje",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Programa",
    accessorKey: "programa",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Formación",
    accessorKey: "new_maestrodecurso",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSMISCURSOS = [
  {
    header: "Formación",
    accessorKey: "new_eventodecapacitacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
];

export const COLUMNSMISLOGROS = [
  {
    header: "Formación (Programa - Curso)",
    accessorFn: (originalRow) => `${originalRow.new_name} - ${originalRow.new_cursomaestro}`,
    size: 100,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Institución",
    accessorKey: "new_institucion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Inicio",
    accessorKey: "new_fechainicio",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha Fin",
    accessorKey: "new_fechafinalizacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  // {
  //   header: "Descarga tu certificado",
  //   accessorFn: (originalRow) => `${originalRow.mimetype} - ${originalRow.documentbody} - ${originalRow.filename}`,
  //   size: 50,
  //   minSize: 100,
  //   maxSize: 200,
  //   Cell: ({ cell }) =>
  //     <IconButton>
  //       <FileDownload onClick={() => {
  //         const [contentType, base64Data, fileName] = cell.getValue().split(' - ');
  //         downloadBase64File(contentType, base64Data, fileName);
  //       }} />
  //     </IconButton>
  // },
  {
    header: "Descarga tu certificado",
    accessorKey: "annotations",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => (
      <>
        {cell.getValue() && cell.getValue().length > 0 ? (
          <IconButton>
            <FileDownload onClick={() => handleDownload(cell.getValue())} />
          </IconButton>
        ) : (
          <p>Esta formación no emite certificado</p>
        )
        }
      </>
    ),
  },
];

const handleDownload = (annotations) => {
  if (Array.isArray(annotations) && annotations.length > 0) {
    annotations.forEach(annotation => {
      const { mimetype, documentbody, filename } = annotation;

      // Verificar si el mimetype es PDF antes de intentar descargar
      if (mimetype === 'application/pdf') {
        downloadBase64File(mimetype, documentbody, filename);
      } else {
        // Manejar el caso de otros tipos de archivos (opcional)
        console.warn(`No se descargará el archivo (${filename}) porque no es un PDF.`);
      }
    });
  } else {
    // Manejar el caso donde no hay annotations
    console.error("No hay annotations para descargar.");
  }
};
